import { ref } from 'vue';

export type ConsentStatus = 'undecided' | 'accepted' | 'declined';

export const CONSENT_STORAGE_KEY = 'analytics-consent';

function readConsent(): ConsentStatus {
  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (stored === 'accepted' || stored === 'declined') return stored;
  } catch {
    // localStorage unavailable (e.g. Safari private browsing, disabled storage)
  }
  return 'undecided';
}

function writeConsent(value: ConsentStatus): void {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch {
    console.warn('[consent] Failed to persist consent to localStorage');
  }
}

interface UseAnalyticsConsentOptions {
  onAccept?: () => void;
  onDecline?: () => void;
}

export function useAnalyticsConsent(options: UseAnalyticsConsentOptions = {}) {
  const status = ref<ConsentStatus>(readConsent());

  if (status.value === 'accepted') {
    options.onAccept?.();
  }

  function accept() {
    status.value = 'accepted';
    writeConsent('accepted');
    options.onAccept?.();
  }

  function decline() {
    status.value = 'declined';
    writeConsent('declined');
    options.onDecline?.();
  }

  return { status, accept, decline };
}
